import { useMemo } from 'react';
import { Text } from "./spectrum/index.js";
import stylesCommon from "./SpectrumComponent.module.css";
import { Tooltip } from "./popper/index.js";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TextWithTooltip(_ref) {
  var text = _ref.text,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top-start' : _ref$placement;
  var options = useMemo(() => ({
    placement
  }), [placement]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      UNSAFE_className: stylesCommon.spectrumEllipsis,
      children: text !== null && text !== void 0 ? text :
      /*#__PURE__*/
      /* &nbsp; so that height doesn't collapse when empty */
      _jsx(_Fragment, {
        children: "\xA0"
      })
    }), text == null || text === '' ? null : /*#__PURE__*/_jsx(Tooltip, {
      options: options,
      children: text
    })]
  });
}
export default TextWithTooltip;
//# sourceMappingURL=TextWithTooltip.js.map